import { render, staticRenderFns } from "./SingleGetInheritedRates.vue?vue&type=template&id=c318e5a6&scoped=true&"
import script from "./SingleGetInheritedRates.vue?vue&type=script&lang=js&"
export * from "./SingleGetInheritedRates.vue?vue&type=script&lang=js&"
import style0 from "./SingleGetInheritedRates.vue?vue&type=style&index=0&id=c318e5a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c318e5a6",
  null
  
)

export default component.exports